import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useTheme } from "next-themes";
import { Check } from "lucide-react";
import PageLayout from "./PageLayout";
import Iridescence from "./Iridescence";
import { Button } from "./ui/button";
import { IRIDESCENCE_DARK, IRIDESCENCE_LIGHT } from "../lib/iridescence";

const MemoIridescence = React.memo(Iridescence);

const CheckoutTransferSuccessPage = () => {
  const { resolvedTheme } = useTheme();
  const navigate = useNavigate();
  const { orderNumber } = useParams();
  const [customerEmail, setCustomerEmail] = useState("");
  const isDark = resolvedTheme === "dark";
  const iridescenceColor = isDark ? IRIDESCENCE_DARK : IRIDESCENCE_LIGHT;

  useEffect(() => {
    if (typeof window === "undefined") return;
    try {
      const saved = JSON.parse(localStorage.getItem("rg_last_order") || "{}");
      if (saved?.orderNumber && String(saved.orderNumber) === String(orderNumber)) {
        setCustomerEmail(saved.email || "");
      }
    } catch (error) {
      setCustomerEmail("");
    }
  }, [orderNumber]);

  return (
    <PageLayout
      className="relative bg-gradient-to-br from-[#fff5e9] via-[#fffaf6] to-[#ffe3c4] dark:from-[#2a0e08] dark:via-[#3b140d] dark:to-[#1f0a08]"
      before={
        <div
          className={`absolute inset-0 pointer-events-none ${isDark ? "opacity-18" : "opacity-28"}`}
          key={`transfer-success-iridescence-${resolvedTheme}`}
        >
          <MemoIridescence color={iridescenceColor} speed={0.5} amplitude={isDark ? 0.1 : 0.12} />
        </div>
      }
    >
      <div className="relative z-10 mx-auto flex w-full max-w-xl flex-col items-center px-4 py-16 text-center">
        <div className="flex flex-col items-center gap-4">
          <img
            src="https://i.imgur.com/upzKk4Y.png"
            alt="RGST Logo"
            className="h-12 w-12 rounded-full shadow-[0_10px_24px_rgba(0,0,0,0.12)]"
          />
          <div className="flex h-20 w-20 items-center justify-center rounded-full bg-emerald-100 text-emerald-600 shadow-[0_12px_30px_rgba(16,185,129,0.25)]">
            <Check className="h-9 w-9" />
          </div>
        </div>
        <h1 className="mt-6 text-3xl font-bold text-foreground">¡Comprobante recibido!</h1>
        <p className="mt-3 text-sm text-muted-foreground">
          Hemos recibido tu comprobante. Te confirmaremos la compra por email en breve.
        </p>
        <p className="mt-4 text-sm font-semibold text-foreground">
          Orden #{orderNumber || "--"}
        </p>
        {customerEmail && (
          <p className="mt-2 text-sm text-muted-foreground">
            Confirmación enviada a <span className="font-medium text-foreground">{customerEmail}</span>
          </p>
        )}
        <Button
          onClick={() => navigate("/")}
          className="mt-8 rounded-full bg-[#7c5cff] px-8 text-white shadow-[0_10px_24px_rgba(124,92,255,0.35)] hover:bg-[#6a4ce6]"
        >
          Volver al inicio
        </Button>
      </div>
    </PageLayout>
  );
};

export default CheckoutTransferSuccessPage;
